/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagKey } from './tagKey';


export interface BusinessObjectDefinitionSearchKey { 
    tagKey?: TagKey;
    /**
     * An optional boolean flag that specifies if business object definition associated with entire tag hierarchy is to be retrieved                
     */
    includeTagHierarchy?: boolean;
    /**
     * The department reference code.
     */
    departmentCode?: string;
    /**
     * An optional boolean flag that specifies if department code must be set (has a non-blank value) for the business object definition that we want to retrieve.                
     */
    mustHaveDepartmentCode?: boolean;
}
